import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const dispatchAdviceRoutesListTodo = createAsyncThunk('dispatchAdviceRoutesList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'dispatch-order-route-planning',
            params: {
                'deliveryDate': data?.date && moment(data?.date).format("YYYY-MM-DD"),
                'routeId': data?.route,
                'dispatchType': data?.dispatchType,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const dispatchAdviceRoutesListSlice = createSlice({
    name: 'dispatchAdviceRoutesList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(dispatchAdviceRoutesListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(dispatchAdviceRoutesListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default dispatchAdviceRoutesListSlice.reducer; 